import ApiService from '../_helper/api.service';
import AdminApiResources from '../../constants/api/resources/wizard';

const TLLSyncService = {
  getHotels() {
    return ApiService.get(AdminApiResources.tllSync);
  },
  setGlobalSync(data: any) {
    return ApiService.post(AdminApiResources.tllSync, data);
  },
  hotelInquiry(data: any) {
    return ApiService.post(AdminApiResources.hotelInquiry, data);
  },
};

export default TLLSyncService;
